module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_10y_n.89787487.csv";